export class SpawnPoint {
  static readonly position1 = 220;
  static readonly position2 = 340;
  static readonly position3 = 460;
  static readonly position4 = 580;
}
